module.exports = __webpack_public_path__ + "img/SketchPngd9bd24a476806b69f8bc3c4aad17ab6445b9601237545d3a57d95af66f07c290.da8429e1.png";